import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";

import withAuthorization from 'layouts/Auth/withAuthorization';

import indexRoutes from 'routes';


class Cabinet extends Component {

	render() {
		return (
	<HashRouter>
		<Switch>
		  {indexRoutes.map((prop, key) => {
		    return <Route to={prop.path} component={prop.component} key={key} />;
		  })}
		</Switch>
	</HashRouter>
		)
	}
}


const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(Cabinet);

// export default withAuthorization(Cabinet);
// export default Cabinet; 


// WEBPACK FOOTER //
// ./src/components/Cabinet/Cabinet.jsx